import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ILead, getLeadById } from 'wisestep-api';
import { WsTitleBanner, FormWizard } from 'wisestep-base';

import { isBlank } from '../../../utils/StringUtils';

import LeadDetailsForm from './LeadDetailsForm';

type LeadFormParams = {
  leadId: string;
};

const LeadForm = () => {
  const navigate = useNavigate();
  const params = useParams<LeadFormParams>();
  const [formWizardCurrentStep, setFormWizardCurrentStep] = useState(0);
  const [leadId, setLeadId] = useState<string>(params.leadId ?? '');
  const [leadData, updateLeadData] = useState<ILead>();

  const fetchLead = useCallback(async () => {
    if (leadId) {
      const response = await getLeadById(leadId);
      if (response.status === 200) {
        updateLeadData(response.data);
      }
    }
  }, [leadId]);

  useEffect(() => {
    fetchLead();
  }, [leadId]);

  const onFormWizardArrowClick = () => navigate('/leads');

  const formWizardMenuItemClick = (id: number) => setFormWizardCurrentStep(id);

  const menuItems = [
    {
      id: 0,
      label: 'Lead Information',
      onClick: () => formWizardMenuItemClick(0),
    },
  ];

  if (!isBlank(leadId) && !leadData) return null;

  return (
    <>
      <FormWizard
        menuItems={menuItems}
        onArrowButtonClick={onFormWizardArrowClick}
        currentStep={formWizardCurrentStep}
        title="Leads List"
      >
        <WsTitleBanner title="Lead Information" backButton={false} />
        {formWizardCurrentStep == 0 && (
          <LeadDetailsForm defaultLeadData={leadData} setLeadId={setLeadId} />
        )}
      </FormWizard>
    </>
  );
};

export default LeadForm;
